import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchSkillDevelopment } from "./SkillDevelopmentAPI";

export const fetchSkillDevelopmentAsync = createAsyncThunk(
    "skillDevelopment/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchSkillDevelopment();
            return response;
        } catch (error) {
            return rejectWithValue(error.message || "Something went wrong");
        }
    }
);

const skillDevelopmentSlice = createSlice({
    name: "skillDevelopment",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSkillDevelopmentAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSkillDevelopmentAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchSkillDevelopmentAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectSkillDevelopmentData = (state) => state.skillDevelopment.data;

export default skillDevelopmentSlice.reducer;